import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  grid: {
    maxWidth: theme.breakpoints.values['md'],
    padding: theme.spacing(2),
    margin: 'auto',
  },
  formGrid: {
    padding: theme.spacing(1),
    width: '100%',
    maxWidth: 300,
    margin: 'auto',
  },
  formItem: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  hidden: {
    display: 'none',
  },
  icon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  flexFilters: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    maxWidth: '560px',
    justifyContent: 'space-around',
    alignItems: (props) => (props.isMobile ? 'center' : 'flex-start'),
  },
  btnGroup: {
    margin: '5px 0',
    backgroundColor: 'transparent',

    '& > button': {
      borderRadius: 100,
      padding: '0px 15px',
    },
  },
  checkRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  filterRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '& .FilterBtn': {
      marginRight: theme.spacing(1),
    },
  },
  filterRowMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  checkIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.primary,
    marginRight: theme.spacing(1),
  },
  smallText: {
    lineHeight: 1.2,
    '& div': {
      display: 'contents',
      fontSize: '0.7rem',
    },
  },
}));

export default useStyles;
